import { createApp } from 'vue'
import LogarithmCalculator from './LogarithmCalculator.vue'
import './assets/global.css'

createApp(LogarithmCalculator).mount('#logarithm')
